/**
 * Set a value in session storage.
 * @param {string} key
 * @param {*} value
 * @returns
 */
export function setSessionStorage(key, value) {
    if (!key) {
        return;
    }
    if (!value) {
        return;
    }
    try {
        window.sessionStorage.setItem(key, value);
    }
    catch {
        console.error("No sessionstorage access.");
    }
};

/**
 * Read a value from session storage.
 * @param {string} key
 * @returns 
 */
export function readSessionStorage(key) {
    if (!key) {
        return null;
    }

    try {
        return window.sessionStorage.getItem(key);
    } catch {
        console.error("No sessionstorage access.");
    }

    return null;
}

/**
 * Set a value in local storage.
 * @param {string} key 
 * @param {*} value 
 * @returns 
 */
export function setLocalStorage(key, value) {
    if (!key) {
        return;
    }

    if (!value) {
        return;
    }

    try {
        window.localStorage.setItem(key, value);
    } catch {
        console.error("No localstorage access.");
    }
};

/**
 * Read a value from local storage.
 * @param {string} key
 * @returns 
 */
export function readLocalStorage(key) {
    if (!key) {
        return null;
    }

    try {
        return window.localStorage.getItem(key);
    } catch {
        console.error("No localstorage access.");
    }

    return null;
};

/**
 * Remove a value from local storage.
 * @param {string} key
 */
export function removeLocalStorage(key) {
    if (!key) {
        return;
    }

    try {
        window.localStorage.removeItem(key);
    } catch {
        console.error("No localstorage access.");
    }
}